module.exports = __webpack_public_path__ + "static/beary-graphic-cb55fe8e8b397aee4c0f4da43718d4db.svg";